var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['table-container', ..._vm.variantClassList]},[(_vm.showHeader)?_c('header',{staticClass:"table-container__header",attrs:{"data-testid":"table-container-header"}},[_vm._t("tableHeader")],2):_vm._e(),_c('div',{directives:[{name:"maxHeight",rawName:"v-maxHeight",value:(_vm.offset),expression:"offset"}],ref:"tableContainer",class:[
			'table-container__tables',
			_vm.isTotalRow && 'table__total-row'
		],style:({
			'--header-height': `${_vm.headerHeight}px`,
			...(_vm.minHeight && { 'min-height': `${_vm.minHeight}px` })
		})},[(!_vm.isTabletMode)?_c('table',{ref:"table",class:['table is-desktop', _vm.responsive && 'is-responsive'],attrs:{"data-testid":"table-desktop"}},[_c('thead',{ref:"tableHeader",staticClass:"table__header"},[_c('tr',{class:['table__tr', _vm.rowAlignmentClass]},[(_vm.hasCheckbox)?_c('th',{staticClass:"table__th table__th--checkbox"},[_c('Checkbox',{attrs:{"value":_vm.isCheckedSelectAll},on:{"change":_vm.onSelectAll}})],1):_vm._e(),_vm._l((_vm.displayColumns),function(column,index){return _c('th',{key:column.columnName,class:[
							'table__th',
							column.columnModifierName !== undefined &&
								'table__th--' + column.columnModifierName,
							column.isSortable && 'is-sortable',
							column.alignDesktop !== undefined &&
								'is-align-' + column.alignDesktop,
							column.sortDirectionClass
						],attrs:{"tabindex":"0","data-testid":"table-desktop-col","data-feature-switch-id":column.featureSwitchId},on:{"click":function($event){return _vm.handleSort(
								_vm.ascending,
								column.columnName,
								index,
								column.sortDirection,
								column.isSortable
							)}}},[(column.isSortable)?_c('div',{staticClass:"table__sort-header"},[_c('span',{staticClass:"table__header-label"},[_vm._v(" "+_vm._s(column.columnDisplayName)+" ")]),_c('div',{staticClass:"table__sort-icons",attrs:{"data-testid":"table-desktop-sort"}},[_c('i',{class:[
										'icon',
										column.sortDirectionIconClass
									],attrs:{"data-testid":"table-desktop-sort-icon"}})])]):_c('span',{staticClass:"table__header-label"},[_vm._v(" "+_vm._s(column.columnDisplayName)+" ")])])})],2)]),_c('tbody',{ref:"tableBody",staticClass:"table__body",attrs:{"data-testid":"table-desktop-body"}},[_vm._l((_vm.displayRecordset),function(record,index){return _c('tr',{key:record.id,class:['table__tr', _vm.rowAlignmentClass]},[(_vm.hasCheckbox)?_c('td',{staticClass:"table__td table__td--checkbox"},[_c('Checkbox',{on:{"change":value => {
									_vm.onSelect(value, index);
								}},model:{value:(_vm.recordset[index][_vm.selectionProp]),callback:function ($$v) {_vm.$set(_vm.recordset[index], _vm.selectionProp, $$v)},expression:"recordset[index][selectionProp]"}})],1):_vm._e(),_vm._l((_vm.displayColumns),function(column){return _c('td',{key:column.columnName,class:[
							'table__td',
							'table__td--' + column.columnModifierName,
							column.alignDesktop !== undefined &&
								'is-align-' + column.alignDesktop
						],attrs:{"data-feature-switch-id":column.featureSwitchId}},[_vm._t(column.slot,function(){return [_c(column.component
										? column.component.name
										: 'span',_vm._g(_vm._b({tag:"component"},'component',
									column.component &&
									column.component.props
										? column.component.props(
												_vm.internalRecordset[index],
												column,
												_vm.dynamicComponentEventHandler
										  )
										: { class: 'table__data' }
								,false),
									column.component &&
									column.component.events
										? column.component.events(
												_vm.internalRecordset[index],
												column,
												_vm.dynamicComponentEventHandler
										  )
										: {}
								),[_vm._v(_vm._s(record[column.columnName]))])]},{"record":_vm.recordset[index]})],2)})],2)}),(_vm.showNoResults)?_c('tr',{attrs:{"data-testid":"table-desktop-body-noresults"}},[_c('td',{style:({
							'min-height': `${_vm.minHeight - _vm.headerHeight}px`,
							padding: `${_vm.noResultsOffset}px`
						}),attrs:{"colspan":_vm.displayColumns.length,"data-testid":"table-desktop-noresults-td"}},[_c('div',{ref:"noResults"},[_vm._t("noResults",function(){return [_c('NoResultsMessage',{attrs:{"visible":true,"primaryTextCondensed":_vm.noResultsPrimaryText,"secondaryTextCondensed":_vm.noResultsSecondaryText}})]})],2)])]):_vm._e()],2)]):_c('table',{class:['table is-tablet'],attrs:{"data-testid":"table-tablet"}},[(_vm.hasCheckbox)?_c('tr',{staticClass:"table__tr"},[_c('th',{staticClass:"table__th"},[_c('Checkbox',{attrs:{"value":_vm.isCheckedSelectAll},on:{"change":_vm.onSelectAll}})],1),_vm._l((_vm.displayRecordset),function(record,index){return _c('td',{key:record.id,staticClass:"table__td"},[_c('Checkbox',{on:{"change":value => {
								_vm.onSelect(value, index);
							}},model:{value:(_vm.recordset[index][_vm.selectionProp]),callback:function ($$v) {_vm.$set(_vm.recordset[index], _vm.selectionProp, $$v)},expression:"recordset[index][selectionProp]"}})],1)})],2):_vm._e(),_vm._l((_vm.displayColumns),function(column,index){return _c('tr',{key:column.columnName,staticClass:"table__tr",class:column.columnModifierName !== undefined &&
						'table__tr--' + column.columnModifierName,attrs:{"data-feature-switch-id":column.featureSwitchId}},[_c('th',{class:[
						'table__th',
						column.columnModifierName !== undefined &&
							'table__th--' + column.columnModifierName,
						column.isSortable && 'is-sortable',
						column.sortDirectionClass
					],attrs:{"tabindex":"0","data-testid":"table-tablet-col"},on:{"click":function($event){return _vm.handleSort(
							_vm.ascending,
							column.columnName,
							index,
							column.sortDirection,
							column.isSortable
						)}}},[(column.isSortable)?_c('div',{staticClass:"table__sort-header"},[_c('span',{staticClass:"table__header-label"},[_vm._v(" "+_vm._s(column.columnDisplayName)+" ")]),_c('div',{staticClass:"table__sort-icons",attrs:{"data-testid":"table-tablet-sort"}},[_c('i',{class:[
									'icon',
									column.sortDirectionIconClass
								],attrs:{"data-testid":"table-tablet-sort-icon"}})])]):_c('span',{staticClass:"table__header-label"},[_vm._v(" "+_vm._s(column.columnDisplayName)+" ")])]),_vm._l((_vm.displayRecordset),function(record,index){return _c('td',{key:record.id,staticClass:"table__td",class:[
						column.columnModifierName !== undefined &&
							'table__td--' + column.columnModifierName,
						column.alignTablet !== undefined &&
							'is-align-' + column.alignTablet
					]},[_vm._t(column.slot,function(){return [_c(column.component
									? column.component.name
									: 'span',_vm._g(_vm._b({tag:"component"},'component',
								column.component && column.component.props
									? column.component.props(
											_vm.internalRecordset[index],
											column,
											_vm.dynamicComponentEventHandler
									  )
									: {}
							,false),
								column.component && column.component.events
									? column.component.events(
											_vm.internalRecordset[index],
											column,
											_vm.dynamicComponentEventHandler
									  )
									: {}
							),[_vm._v(_vm._s(record[column.columnName]))])]},{"record":_vm.recordset[index]})],2)})],2)}),(_vm.showNoResults)?_c('tr',{attrs:{"data-testid":"table-tablet-noresults"}},[_vm._t("noResults",function(){return [_c('NoResultsMessage',{attrs:{"visible":true,"primaryTextCondensed":_vm.noResultsPrimaryText,"secondaryTextCondensed":_vm.noResultsSecondaryText}})]})],2):_vm._e()],2),_c('portal-target',{attrs:{"name":_vm.portalTargetName || 'tableLoader'}})],1),(_vm.isTotalRow && _vm.$slots['tableFooter'])?_c('footer',{staticClass:"table-container__footer",attrs:{"data-testid":"table-footer"}},[_vm._t("tableFooter")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }